<template>
  <div class="popupMask" @click="popupMaskClicked">
    <div class="popupWrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popupWrapper',
  methods: {
    popupMaskClicked: function() {
      this.$emit('popup-mask-clicked');
    }
  }
};
</script>
